import { userApiPost } from './apiPost'

export const fetchDashboard = userApiPost('get-dashboard')

export const getLastYearEachMonthProviders = userApiPost('last-year-each-month-providers')

export const getLastYearEachMonthClients = userApiPost('last-year-each-month-clients')

export const getLastYearEachMonthAlerts = userApiPost('last-year-each-month-alerts')

export const getAlertsSummary = userApiPost('get-alerts-summary')

export const getOpenOrClosedAlertsSummary = userApiPost('get-open-or-closed-alerts-summary')

export const getIndicatorCounts = userApiPost('get-indicator-counts')

export const getLatestTwentyAlerts = userApiPost('get-latest-twenty-alerts')

export const getLatestTwentyIndicators = userApiPost('get-latest-twenty-indicators')

export const getLastYearLogsCounts = userApiPost('get-last-year-logs-counts')

export const getUserName = userApiPost('get-user-name')
